<template>
  <div v-if="list.length && showLayer" class="layer-page flex-center" @touchmove.prevent>
    <div class="layer-page-body">
      <div class="layer-page-body-header flex-row-center-between">
        <p class="font-14 font-bold" style="color: #5C6699;">全部</p>
        <img class="cursor" src="@/assets/shjk/icon-tp-close.png" @click="closeLayer">
      </div>
      <div class="layer-page-body-list flex">
        <div v-for="(item, index) in list" :key="index" class="layer-page-body-list-item" @click="toDetail(item)">
          <el-image class="cover transition" :src="'https://img.libraryplus.bjadks.com/' + item.coverImage" fit="cover">
            <div slot="placeholder" class="image-slot">
              <img class="match-height match-width" src="../../../assets/img/icon-default.jpg">
            </div>
            <div slot="error" class="image-slot ">
              <img class="match-height match-width" src="../../../assets/img/icon-default.jpg">
            </div>
          </el-image>
          <p class="name text-line-1">{{ item.name }}</p>
          <p class="info text-line-4">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      list: [],
      showLayer: 0
    }
  },
  methods: {
    showList(data) {
      this.stopScroll()
      this.list = data
      this.showLayer = true
    },
    closeLayer() {
      this.canScroll()
      this.list = []
      this.showLayer = false
    },
    toDetail(v) {
      const { type, dataId, catalogId } = v
      if (type === 4) {
        const page = this.$router.resolve({
          path: '/source',
          query: {
            cateId: catalogId,
            sourceId: dataId
          }
        })
        window.open(page.href, '_blank')
      } else {
        const page = this.$router.resolve({
          path: '/entity',
          query: {
            cateId: catalogId,
            sourceId: dataId
          }
        })
        window.open(page.href, '_blank')
      }
    }
  }
}
</script>

<style scoped>

.layer-page {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(100px);
}

.layer-page-body {
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  width: 1240px;
  height: 600px;
}

.layer-page-body-header {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #eee;
  padding: 0 20px;
}

.layer-page-body-list {
  height: 550px;
  padding: 20px;
  flex-wrap: wrap;
  overflow-y: scroll;
  background: rgba(255, 255, 255, 0.9);
}

.layer-page-body-list-item {
    width: 224px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .layer-page-body-list-item:nth-child(5n) {
    margin-right: 0;
  }

  .layer-page-body-list-item .cover {
    width: 224px;
    height: 145px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .layer-page-body-list-item .name {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 0.75);
  }

  .layer-page-body-list-item .info {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.75);
    line-height: 20px;
  }

</style>

<style lang="scss" scoped>
.layer-page-body-list::-webkit-scrollbar {
 width: 6px;
}

.layer-page-body-listt::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.4);

 &:hover {
  background: rgba(255, 255, 255, 0.4);
 }

 &:active {
  background: rgba(255, 255, 255, 0.4);
 }
}

.layer-page-body-list {
 scrollbar-width: thin;
 scrollbar-color: rgba(255, 255, 255, 0.4) rgba(255, 255, 255, 0.4);
}

::-webkit-scrollbar{
    display: none;
}
</style>
